import { IncidentDetailsMessage } from "@/modules/PhishTitan/types/IncidentSummary";
import { ThreatCoachIndicator } from "../types/threatCoach";
import { highlightKeywordsInInnerHtml } from "./highlightKeysInInnerHtml";
import { parseInnerHtml, MessageForParse } from "./parseInnerHtml";
import { transformThreatCoachIndicatorsToKeywords } from "./transformThreatCoachIndicatorsToKeywords";

export const getHighlightedEmail = ({
  message,
  indicators,
  isThemeDark,
}: {
  message: Pick<IncidentDetailsMessage, "body" | "subject" | "sender_mail">;
  indicators: ThreatCoachIndicator[];
  isThemeDark: boolean;
}): string | undefined => {
  if (!message?.body) {
    return;
  }
  if (!["html", "text"].includes(message.body.content_type)) {
    return;
  }

  const keywords = transformThreatCoachIndicatorsToKeywords(indicators);
  if (!keywords.length) {
    return;
  }
  const messageForParse: MessageForParse = {
    body: message.body,
    subject: message.subject,
    sender_mail: message.sender_mail,
  };
  const parsedHtml = parseInnerHtml(messageForParse, isThemeDark);

  return highlightKeywordsInInnerHtml(parsedHtml, keywords);
};
